import { render, staticRenderFns } from "./Grafica3.vue?vue&type=template&id=6b2dba4e&"
import script from "./Grafica3.vue?vue&type=script&lang=js&"
export * from "./Grafica3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports